import dmyt_to_ymdt from "./dmyt_to_ymdt";

export function meets_minimum_version(minimum_version_maybe) {
	if (!(minimum_version_maybe && /^\d{12}$/.test(minimum_version_maybe))) return true;

	return dmyt_to_ymdt(__BUILD__) >= dmyt_to_ymdt(String(minimum_version_maybe))

}